import { render, staticRenderFns } from "./PolicyWizard.vue?vue&type=template&id=43d4e13f&scoped=true&"
import script from "./PolicyWizard.vue?vue&type=script&lang=js&"
export * from "./PolicyWizard.vue?vue&type=script&lang=js&"
import style0 from "./PolicyWizard.vue?vue&type=style&index=0&id=43d4e13f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d4e13f",
  null
  
)

export default component.exports